// src/utils/pathUtils.ts

/**
 * Extract type from path like "widgets/nav" -> "nav"
 * This utility should be used at the calling place to convert paths to types
 * before passing to loadWidget or other loader functions
 */
/**
 * Extract template ID from URL pathname
 * Extracts template ID from URL like /casual_dining/preview or /casual_dining
 * @returns The first path segment as template ID, defaults to 'casual_dining' if not found
 */
export const getTemplateIdFromUrl = (): string => {
  const pathname = window.location.pathname;
  // Extract template ID from URL like /casual_dining/preview or /casual_dining
  const pathSegments = pathname.split('/').filter(segment => segment.length > 0);
  
  // Return the first segment as template ID, default to 'casual_dining' if not found
  return pathSegments.length > 0 ? pathSegments[0] : 'pizza';
};
